import { ajaxAuth } from "@tm/utils"

import { getBundleParams } from "../../utils"
import { CheckVehicleRequest, CheckVehicleResponse, MergeRegistrationNoDetailsRequest } from "../model/gsi"

function getGsiServiceUrl(): string {
    return getBundleParams().gsiServiceUrl
}

export function checkGsiVehicle(body: CheckVehicleRequest) {
    return ajaxAuth<CheckVehicleResponse>({
        url: `${getGsiServiceUrl()}/Vehicles/CheckVehicle`,
        body,
    })
}

export function mergeRegistrationNoDetails(body: MergeRegistrationNoDetailsRequest) {
    return ajaxAuth({
        method: "POST",
        url: `${getGsiServiceUrl()}/Vehicles/MergeRegistrationNoDetails`,
        body,
    })
}
